import { SET_BREADCRUMB } from '../actions/types';

const initialState = [];

export default function breadcrumbReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_BREADCRUMB:
            return payload;
        default:
            return state;
    }
}
